import styles from './FirmDashboardJobCount.module.css'

export interface FirmDashboardJobCountProps {
  totalJobs?: number
}

export function FirmDashboardJobCount({
  totalJobs,
}: FirmDashboardJobCountProps) {
  return (
    <div className={styles.root}>
      Jobs
      <span className={styles.resultCount}>({totalJobs ?? 0})</span>
    </div>
  )
}
